import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Colors,
    PointElement,
    LineElement,
    LineController,
    BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { useTheme } from "@emotion/react";
import { getDesignBackgroundColors } from "../../utils/chartPatterns";

const ScoreGraphCost = forwardRef(({ variants, designs }, ref) => {
    const styling = useTheme();

    const baseColor = styling.palette.graphics.primaryCyan;
    const dataSets = [
        {
            data: designs.map((design) => design.investment_cost),
            backgroundColor: getDesignBackgroundColors(
                designs,
                [baseColor]
            ),
            label: "Investering",
            // Store solid color for potential legend use
            legendColor: baseColor,
        }
    ] 

    ChartJS.register(
        LinearScale,
        CategoryScale,
        BarElement,
        PointElement,
        LineElement,
        Legend,
        Tooltip,
        LineController,
        BarController,
        Colors,
        Title
    );
    const options = {
        plugins: {
            title: {
                display: true,
                text: "Investeringskosten",
                font: {
                    size: 14,
                },
            },
            legend: {
                display: false,
            },
        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                title: {
                    display: true,
                    text: "Kosten (€)",
                },
            },
        },
    };

    const data = {
        labels: variants,
        datasets: dataSets,
    };
    if (data === null) {
        return null;
    }

    return <Chart ref={ref} type="bar" options={options} data={data} redraw />;
});

ScoreGraphCost.displayName = 'ScoreGraphCost';

ScoreGraphCost.propTypes = {
    variants: PropTypes.array.isRequired,
    designs: PropTypes.array.isRequired,
};

export default ScoreGraphCost;
